/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StorageNodeMini,
    StorageNodeMiniFromJSON,
    StorageNodeMiniFromJSONTyped,
    StorageNodeMiniToJSON,
} from './';

/**
 * 
 * @export
 * @interface LizardFSDisk
 */
export interface LizardFSDisk {
    /**
     * 
     * @type {StorageNodeMini}
     * @memberof LizardFSDisk
     */
    node?: StorageNodeMini | null;
    /**
     * 
     * @type {string}
     * @memberof LizardFSDisk
     */
    host: string;
    /**
     * 
     * @type {string}
     * @memberof LizardFSDisk
     */
    mountpoint: string;
    /**
     * 
     * @type {boolean}
     * @memberof LizardFSDisk
     */
    toDelete: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LizardFSDisk
     */
    damaged: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LizardFSDisk
     */
    scanning: boolean;
    /**
     * 
     * @type {number}
     * @memberof LizardFSDisk
     */
    errorChunk: number;
    /**
     * 
     * @type {number}
     * @memberof LizardFSDisk
     */
    errorTimestamp: number;
    /**
     * 
     * @type {number}
     * @memberof LizardFSDisk
     */
    sizeTotal: number;
    /**
     * 
     * @type {number}
     * @memberof LizardFSDisk
     */
    sizeUsed: number;
    /**
     * 
     * @type {number}
     * @memberof LizardFSDisk
     */
    sizeFree: number;
    /**
     * 
     * @type {number}
     * @memberof LizardFSDisk
     */
    chunks: number;
}

export function LizardFSDiskFromJSON(json: any): LizardFSDisk {
    return LizardFSDiskFromJSONTyped(json, false);
}

export function LizardFSDiskFromJSONTyped(json: any, ignoreDiscriminator: boolean): LizardFSDisk {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'node': !exists(json, 'node') ? undefined : StorageNodeMiniFromJSON(json['node']),
        'host': json['host'],
        'mountpoint': json['mountpoint'],
        'toDelete': json['to_delete'],
        'damaged': json['damaged'],
        'scanning': json['scanning'],
        'errorChunk': json['error_chunk'],
        'errorTimestamp': json['error_timestamp'],
        'sizeTotal': json['size_total'],
        'sizeUsed': json['size_used'],
        'sizeFree': json['size_free'],
        'chunks': json['chunks'],
    };
}

export function LizardFSDiskToJSON(value?: LizardFSDisk | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'node': StorageNodeMiniToJSON(value.node),
        'host': value.host,
        'mountpoint': value.mountpoint,
        'to_delete': value.toDelete,
        'damaged': value.damaged,
        'scanning': value.scanning,
        'error_chunk': value.errorChunk,
        'error_timestamp': value.errorTimestamp,
        'size_total': value.sizeTotal,
        'size_used': value.sizeUsed,
        'size_free': value.sizeFree,
        'chunks': value.chunks,
    };
}


